import React from 'react'
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import Tr from 'translations/Translations';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconDeactivateButton(
    {
        tooltip = Tr('deactivate'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={ToggleOnIcon}
        {...props}
    />
}

WorkableIconDeactivateButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconDeactivateButton;